import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { FormLabelStyled } from './styled';

export const TextField = ({ label, ...props }: TextFieldProps) => {
  return (
    <>
      {label && <FormLabelStyled>{label}</FormLabelStyled>}
      <MuiTextField variant="outlined" {...props} />
    </>
  );
};
